const INSIDER_TRACKED_ORDERS_KEY = 'insider_tracked_orders';

export const hasOrderBeenTracked = (orderId: string): boolean => {
  const tracked = getTrackedOrders();
  return tracked.includes(orderId);
};

export const markOrderAsTracked = (orderId: string): void => {
  const tracked = getTrackedOrders();
  if (!tracked.includes(orderId)) {
    tracked.push(orderId);
    localStorage.setItem(INSIDER_TRACKED_ORDERS_KEY, JSON.stringify(tracked));
  }
};

export const clearTrackedOrders = (): void => {
  localStorage.removeItem(INSIDER_TRACKED_ORDERS_KEY);
};

const getTrackedOrders = (): Array<string> => {
  try {
    const stored = localStorage.getItem(INSIDER_TRACKED_ORDERS_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch {
    return [];
  }
};
